import { FormControl } from '@angular/forms';

export function validateEmptyField(c: FormControl) {
    return c.value && !c.value.trim() ? {
      required: {
        valid: false
      }
    } : null;
  }
